<template>
  <el-select :size="size"
             :value="value"
             :multiple="multiple"
             :collapse-tags="collapseTags"
             :filterable="filterable"
             :disabled="disabled"
             :clearable="clearable"
             @change="change($event)" :class="{'width100': width100}">
    <el-option v-for="customer in customers" :key="customer['id']"
               :value="customer['id']" :label="customer['name']"
    ></el-option>
  </el-select>
</template>

<script>

  import BillingServer from '@/api/billing';

  export default {
    name: "CustomerSelect",
    props: {
      size: {},
      value: {},
      multiple: {},
      collapseTags: {},
      filterable: {},
      clearable: {},
      disabled: {},

      width100: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        customers: [],
      };
    },
    methods: {
      load() {
        BillingServer.customer.list().then(res => {
          if (res.data.success) {
            this.customers = res.data.data == null ? [] : res.data.data;
            this.$emit('loaded', this.customers);
          } else {
            this.customers = [];
            this.$message.error(res.data.responseMessage)
          }
        }, error => {
          this.$message.error(error || '加载客户信息数据异常')
        });
      },
      change(event) {
        this.$emit('input', event);
        this.$emit('change', [event, this.customers.filter(customer => customer['id'] === event)[0]]);
      },
    },
    mounted() {
      this.load();
    }
  }
</script>

<style scoped>

</style>
